// export const baseUrl = 'https://employeemgtapi.herokuapp.com';
export const baseUrl = "https://ats.outcess.com";
export const hrmsBaseUrl = "https://hr.outcess.com";
export const blogKey = "AIzaSyBAMS6ASReYZMBN_Y59AO6AQvhzdbQMzW0";
